<template>
  <v-card id="contract-scale-summary-dialog">
    <v-card-title class="primary white--text">
      <v-icon color="white" class="mr-2">mdi-ruler-square</v-icon>
      <span>{{ title }}</span>
      <v-spacer/>
      <BaseDialogActions hideRefresh />
    </v-card-title>
    <v-card-text class="pt-4">
      <v-data-table
        dense
        :headers="headers"
        :items="lines"
        hide-default-footer
        :items-per-page="-1"
        class="small-headers">
        <template #item.rate="{ item }">{{ formatMoney(item.rate) }}</template>
        <template #item.grossVolume="{ item }">{{ mbfStringFromBf(item.grossVolume) }}</template>
        <template #item.netVolume="{ item }">{{ mbfStringFromBf(item.netVolume) }}</template>
        <template #item.amount="{ item }">{{ formatMoney(item.amount) }}</template>
        <template #body.append>
          <tr class="font-weight-bold">
            <td :colspan="headers.length - 3">{{ $t('total') }}</td>
            <td class="text-right">{{ mbfStringFromBf(totals.grossVolume) }}</td>
            <td class="text-right">{{ mbfStringFromBf(totals.netVolume) }}</td>
            <td class="text-right">{{ formatMoney(totals.amount) }}</td>
          </tr>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { formatMoney, mbfStringFromBf } from '@/utils/NumericMutations'

export default {
  name: 'ContractScaleSummaryDialog',

  components: {
    BaseDialogActions: () => import('@/components/core/BaseDialogActions.vue')
  },

  props: {
    lines: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },

  computed: {

    headers () {
      const variableColumns = [
        { text: this.$t('species'), value: 'speciesGroupName' },
        { text: this.$t('lengthGroup'), value: 'lengthGroupName' },
        { text: this.$t('diameterGroup'), value: 'diameterGroupName' },
        { text: this.$t('grade'), value: 'gradeName' },
        { text: this.$t('endUseSort'), value: 'endUseSortName' }
      ].filter(col => this.lines.some(l => l[col.value]))

      return [
        ...variableColumns,
        { text: this.$t('rate'), value: 'rate', align: 'right' },
        { text: this.$t('grossMbf'), value: 'grossVolume', align: 'right' },
        { text: this.$t('netMbf'), value: 'netVolume', align: 'right' },
        { text: this.$t('amount'), value: 'amount', align: 'right' }
      ]
    },

    totals () {
      return this.lines.reduce((acc, l) => ({
        grossVolume: acc.grossVolume + (l.grossVolume ?? 0),
        netVolume: acc.netVolume + (l.netVolume ?? 0),
        amount: acc.amount + (l.amount ?? 0)
      }), { grossVolume: 0, netVolume: 0, amount: 0 })
    }
  },

  methods: {
    formatMoney,
    mbfStringFromBf
  }
}
</script>
